import React from "react";
import ReactDom from "react-dom";
import "./styles.css";
import App from "./App";

const rootElement = document.getElementById("root");
ReactDom.render(<App />, rootElement);
